import { render, staticRenderFns } from "./customer-assignation.vue?vue&type=template&id=2e3e6298&"
import script from "./customer-assignation.vue?vue&type=script&lang=js&"
export * from "./customer-assignation.vue?vue&type=script&lang=js&"
import style0 from "./customer-assignation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports